module.exports = __webpack_public_path__ + "Project.c9fc7a11271a55ee2fb44b00548f20e2.hashedasset.svg";


//////////////////
// WEBPACK FOOTER
// ./app/img/getting-started/Project.svg
// module id = 5001567048964959
// module chunks = 1